<p-toast />
<p-table
  #permissionTbl
  [value]="permissionsWithCategory()"
  stripedRows
  [paginator]="true"
  [rows]="15"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} permissions"
  [rowsPerPageOptions]="[5, 10, 15, 20, 50, 100]"
  [loading]="permissionService.isLoading()"
  [globalFilterFields]="['name', 'categoryName']"
>
  <ng-template #caption>
    <div class="flex">
      <p-iconfield class="ml-auto">
        <p-inputicon class="pi pi-search" />
        <input
          #searchInput
          type="text"
          pInputText
          placeholder="Search"
          (input)="permissionTbl.filterGlobal($event.target.value, 'contains')"
        />
        <p-inputicon
          class="pi pi-times text-red-600 hover:cursor-pointer"
          (click)="searchInput.value = ''; permissionTbl.clear()"
        />
      </p-iconfield>
    </div>
  </ng-template>
  <ng-template #header>
    <tr>
      <th></th>
      <th pSortableColumn="name">Name <p-sortIcon field="name" /></th>
      <th>Description</th>
      <th pSortableColumn="categoryName" class="hidden md:table-cell">
        Category <p-sortIcon field="categoryName" />
      </th>
    </tr>
  </ng-template>
  <ng-template #body let-permission>
    <tr>
      <td style="width: 5rem">
        <p-button
          icon="pi pi-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          (click)="editPermission(permission)"
        />
      </td>
      <td>{{ permission.name }}</td>
      <td>{{ permission.description }}</td>
      <td>{{ permission.categoryName }}</td>
    </tr>
  </ng-template>
</p-table>
<p-dialog
  [(visible)]="permissionDialog"
  [style]="{ width: '450px' }"
  header="Permission Details"
  [modal]="true"
>
  <ng-template #content>
    <div class="flex flex-col gap-6">
      <div>
        <label for="name" class="block font-bold mb-3">Name</label>
        <input
          type="text"
          pInputText
          id="name"
          [(ngModel)]="permission.name"
          required
          autofocus
          fluid
        />
        @if (submitted && permission && !permission.name) {
          <small class="text-red-500">Name is required.</small>
        }
      </div>
      <div>
        <label for="description" class="block font-bold mb-3"
          >Description</label
        >
        <textarea
          id="description"
          pTextarea
          [(ngModel)]="permission.description"
          required
          rows="3"
          cols="20"
          class="w-full"
        ></textarea>
      </div>
      <div>
        <label for="category" class="block font-bold mb-3">Category</label>
        <p-select
          [(ngModel)]="permission.category_id"
          inputId="categoryId"
          [options]="permissionCategories()"
          optionLabel="label"
          optionValue="value"
          placeholder="Select a category"
          appendTo="body"
          fluid
        />
      </div>
      <div>
        <span class="block font-bold mb-4">Groups</span>
        <div class="grid grid-cols-12 gap-4">
          @for (group of permissionService.permissionGroups(); track group.id) {
            <div class="flex items-center gap-2 col-span-6">
              <p-checkbox
                inputId="group{{ group.id }}"
                name="group"
                [value]="group.id"
                [(ngModel)]="permission.group_ids"
              />
              <label for="group{{ group.id }}"> {{ group.name }} </label>
            </div>
          }
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footer>
    <p-button label="Cancel" icon="pi pi-times" text (click)="hideDialog()" />
    <p-button label="Save" icon="pi pi-check" (click)="savePermission()" />
  </ng-template>
</p-dialog>
